__turbopack_context__.v({
  "root": "ArticleFilterbar-module__S0Apha__root",
  "tag": "ArticleFilterbar-module__S0Apha__tag",
});
